import { Package } from "@/types/packages/data-only/DataOnlyCountryPackages";

export function categorizedDataOnlyPackages(packages: Package[] | undefined) {
  const dataOnlyPackages = (packages ?? []).filter(
    (p) => p.package_type === "DATA-ONLY",
  );

  const unlimitedPackages = dataOnlyPackages.filter(
    (p) => p.data_quantity <= -1,
  );

  const limitedPackages = dataOnlyPackages.filter((p) => p.data_quantity > 0);

  return {
    limitedPackages,
    unlimitedPlusPackages: unlimitedPackages.filter(
      (p) => p.data_unit === "Plus",
    ),
    unlimitedPremiumPackages: unlimitedPackages.filter(
      (p) => p.data_unit === "Premium",
    ),
    unlimitedDataPackages: unlimitedPackages.filter(
      (p) => p.data_unit !== "Plus" && p.data_unit !== "Premium",
    ),
  };
}
